import * as types from '../types';

export default {
  [types.GET_CLIENT_TYPE](state, data) {
    state.clientType = data.results;
  },
  [types.GET_CLIENT_AUDIT_LIST](state, data) {
    state.clientAuditData = data;
  },
  [types.GET_CLIENT_AUDIT_DETAIL](state, data) {
    state.clientAuditDetail = data;
  },
  [types.GET_AUDIT_CONTACTS_LIST](state, data) {
    state.auditContacts = data;
  },
};
